// extracted by mini-css-extract-plugin
export default {"infoCardContainer":"InfoCard_infoCardContainer__n+sbP","infoCardText":"InfoCard_infoCardText__4EhgA"};